import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { DriverActivityGanttComponent } from "./driverActivityGantt.component";
import { DriversController } from "./drivers.controller";
import { DriverScoreComponent } from "./driverScore.component";
import { DriversPageComponent } from "./driversPage/driversPage.component";
import { DriverViewComponent } from "./driverView/driverView.component";
import { SimpleBarChartComponent } from "./simpleBarChart.component";

export class Config {

    static $inject = ["$stateProvider"];

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(FleetNavigationModule.Drivers, {
            url: "/drivers",
            views: { "content@app": { component: "driversPage" } },
            data: { translation: "Common.Drivers" }
        });

        $stateProvider.state(FleetNavigationModule.DriverView, {
            url: "/:driverId",
            views: { "content-detail@app": { component: "driverView", bindings: { driverId: "driverId" } } },
            data: { displayName: 'View Driver'/*, translation: 'Foundation.ViewCustomers' */},
            params: {
                driverId: {
                    squash: true,
                    value: null
                },
            },
            resolve: {
                driverId: ["$stateParams", ($stateParams) => { return $stateParams["driverId"]; }]
            }
        });



        $stateProvider.state(FleetNavigationModule.Drivers_Old, {
            url: "/drivers2/:driver/:page/:option",
            views: {
                "content@app": {
                    template: require("./drivers.html"),
                    controller: "driversController as $ctrl"
                }
            },
            params: {
                title: "Drivers",
                driver: { squash: true, value: null, dynamic: true },
                page: { squash: true, value: null, dynamic: true },
                option: { squash: true, value: null, dynamic: true }
            }
        });
    }
}

angular
    .module("app.components.drivers", [
        "ui.router",
        "app.components.util.api"
    ])
    .config(Config)

    .controller("driversController", DriversController)

    .component("driversPage", new DriversPageComponent())
    .component("driverView", new DriverViewComponent())

    .component("simpleBarChart", new SimpleBarChartComponent())
    .component("driverScore", new DriverScoreComponent())
    .component("driverActivityGantt", new DriverActivityGanttComponent());
